/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';
import { Events } from '@app/events/events/events.model';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WebsitesService } from '@app/settings/websites/websites.service';
import { EventsService } from '@app/events/events/events.service';
import { Logger } from '@app/core';
import { ApiQuery } from '@app/core/http/api-query';

const log = new Logger('EventsSeoFormComponent');

@Component({
  selector: 'app-events-seo-form',
  templateUrl: './events-seo-form.component.html',
  styleUrls: ['./events-seo-form.component.scss'],
})
export class EventsSeoFormComponent implements OnInit {
  @Input() eventSeo: Events = null;
  form: FormGroup;
  companyWebsiteLocales: Array<any>;
  currentWebsiteLocaleId: number;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private websitesService: WebsitesService,
    private eventService: EventsService
  ) {}

  ngOnInit() {
    log.debug(this.eventSeo);
    this.createForm();
    this.getData();
  }

  save() {
    log.debug(this.form.get('websiteLocales').value);
    this.eventService
      .updateTranslations(this.eventSeo, { translations: this.form.get('websiteLocales').value })
      .subscribe((res: any) => {
        this.modal.close(res);
      });
  }

  selectCompanyWebSiteLocale(id: number): void {
    this.currentWebsiteLocaleId = id;
  }

  getWebsiteLocaleName(id: number): string {
    const localeObj = this.companyWebsiteLocales.find((x) => x.id === id);
    return localeObj.website.name + ' ' + localeObj.website.url + ' ' + localeObj.locale.locale;
  }

  addFact(websiteLocale: any) {
    // @ts-ignore
    websiteLocale.controls.facts.push(this.getEmptyFact());
  }

  removeFact(websiteLocale: any, index: number) {
    log.debug('websiteLocale', websiteLocale);
    websiteLocale.get('facts')['controls'].splice(index, 1);
    websiteLocale.get('facts').updateValueAndValidity();
  }

  private createForm(): void {
    this.form = this.formBuilder.group({
      websiteLocales: new FormArray([]),
    });
  }

  private getData() {
    this.websitesService.getLocales().subscribe((websiteLocales: []) => {
      this.companyWebsiteLocales = websiteLocales;
      const formArray: FormArray = new FormArray([]);
      websiteLocales.forEach((websiteLocale: any) => {
        formArray.push(
          new FormGroup({
            company_website_locale_id: new FormControl(websiteLocale.id),
            description: new FormControl(null),
            slug: new FormControl(null),
            meta_title: new FormControl(null),
            meta_description: new FormControl(null),
            active: new FormControl(true),
            top: new FormControl(false),
            top_in_venues: new FormControl(false),
            facts: new FormArray([]),
          })
        );
      });
      this.form.setControl('websiteLocales', formArray);

      // Взема информацията от API-то и patch-ва контролите един по един
      const query = new ApiQuery().addIncludes('translations');
      this.eventService.show(this.eventSeo.id, query).subscribe((event: Events) => {
        event.translations.forEach((translation: any) => {
          this.form.get('websiteLocales')['controls'].forEach((websiteLocaleControl: FormControl, ind: number) => {
            if (
              translation.company_website_locale_id ===
              Number(websiteLocaleControl.get('company_website_locale_id').value)
            ) {
              if (translation.facts.length > 0) {
                this.form
                  .get('websiteLocales')
                  ['controls'][ind].setControl('facts', this.createManyFacts(translation.facts));
              }

              websiteLocaleControl.patchValue(translation);
            }
          });
        });
      });
    });
  }

  private getEmptyFact(): FormGroup {
    return new FormGroup({
      icon: new FormControl(null),
      count: new FormControl(null),
      label: new FormControl(null),
    });
  }

  private createManyFacts(facts: Array<any>): FormArray {
    const formArray: FormArray = new FormArray([]);
    facts.forEach(() => {
      formArray.push(this.getEmptyFact());
    });
    return formArray;
  }
}
